// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"ss_a bhp_b bhp_bj","HomeBaseBanner__hint":"ss_b bhp_vh","HomeBaseBanner__link":"ss_c"};